import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataTableEvent } from '../../data-table/data-table.component';
import { GroupService } from '@services/groups/group.service';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'group-selection',
    templateUrl: './group-selection.component.html',
    styleUrls: ['./group-selection.component.scss'],
    providers: [GroupService],
    standalone: false
})
export class GroupSelectionComponent implements OnInit {

  public columns = [
    {
      prop: 'name', translationString: 'general.name',
      valueTransformer: (val) => (val || '').startsWith('pref_') ? val.split('_').splice(2, val.split('_').length - 1).join('_') : val
    }
  ];

  dataProviderParams = {};
  selectedGroupIds = [];

  private addedItems = [];
  private removedItems = [];

  constructor(
    public dialogRef: MatDialogRef<GroupSelectionComponent>,
    public groupService: GroupService,
    public translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    if (this.data.params) {
      this.dataProviderParams = this.data.params;
    }
    if (this.data.assignedGroupIds) {
      this.selectedGroupIds = this.data.assignedGroupIds;
    }
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({ added: this.addedItems, removed: this.removedItems, all: this.selectedGroupIds });
  }

  selected(event: DataTableEvent) {
    if (this.selectedGroupIds.indexOf(event.row.GroupID) > -1) {
      this.selectedGroupIds.splice(this.selectedGroupIds.indexOf(event.row.GroupID), 1);
      this.removedItems.push(event.row.GroupID);
      if (this.addedItems.indexOf(event.row.GroupID) > -1) {
        this.addedItems.splice(this.addedItems.indexOf(event.row.GroupID), 1);
      }
    } else {
      this.selectedGroupIds.push(event.row.GroupID);
      this.addedItems.push(event.row.GroupID);
      if (this.removedItems.indexOf(event.row.GroupID) > -1) {
        this.removedItems.splice(this.removedItems.indexOf(event.row.GroupID), 1);
      }
    }
  }

}
